import React from 'react';

export default () => (
  <svg width="22" height="21" viewBox="-1 -1 24 23" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g fill="#2D2F31">
        <g>
          <path d="M21.954 21h-8.628v-1.04l1.018-.088c.445-.039.75-.098.916-.176.293-.117.508-.295.644-.534.137-.24.205-.55.205-.93v-7.398H6.34v7.236c0 .342.056.63.168.865.113.234.335.439.667.615.166.088.461.176.886.263.425.088.76.137 1.003.147V21H.436v-1.04l1.018-.088c.444-.039.75-.098.915-.176.293-.117.508-.295.645-.534.136-.24.205-.55.205-.93v-15a1.92 1.92 0 0 0-.19-.857c-.128-.26-.347-.462-.66-.608a5.3 5.3 0 0 0-.96-.337 5.535 5.535 0 0 0-.973-.176V.214h8.627v1.04a6.53 6.53 0 0 0-1.003.132c-.395.078-.69.151-.886.22-.332.117-.554.312-.667.585a2.33 2.33 0 0 0-.168.894V9.53h9.77V3.231a1.92 1.92 0 0 0-.19-.856c-.127-.26-.347-.462-.66-.608a5.3 5.3 0 0 0-.959-.337 5.535 5.535 0 0 0-.974-.176V.214h8.628v1.04a6.53 6.53 0 0 0-1.003.132c-.396.078-.691.151-.887.22-.332.117-.554.312-.666.585a2.33 2.33 0 0 0-.169.894V18.07c0 .342.057.63.169.865.112.234.334.439.666.615.166.088.462.176.887.263.424.088.759.137 1.003.147V21z" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/fd-headings.es6.js